// react-redux imports
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "app/store";

// common imports
import SectionTitle from "common/components/styled-components/SectionTitle";
import SectionTitleIndication from "common/components/styled-components/SectionTitleIndication";
import Slider from "common/components/Slider";

import UserInputSection from "../styled-components/UserInputSection";

import { setElectricityExpenseMonthly } from "./energySlice";

function StepOne() {
  const dispatch = useDispatch();
  const electricityExpenseMonthly = useSelector(
    (state: RootState) => state.calculator.energy.electricityExpenseMonthly
  );

  const [electricityExpense, setElectricityExpense] = useState([
    electricityExpenseMonthly,
  ]);

  function onFinalChange(values: number[]) {
    dispatch(setElectricityExpenseMonthly(values[0]));
  }

  return (
    <>
      <SectionTitle>
        <span>¿Cuánto es tu gasto en electricidad? </span>
        <SectionTitleIndication>(mensual, en €)</SectionTitleIndication>
      </SectionTitle>
      <UserInputSection>
        <Slider
          min={0}
          max={150}
          maxIndicator="+150"
          values={electricityExpense}
          onChange={setElectricityExpense}
          onFinalChange={onFinalChange}
        />
      </UserInputSection>
    </>
  );
}

export default StepOne;
